export const thfPageJobSchedulerLiteralsDefault = {
  en: {
    at: 'at',
    back: 'Back',
    next: 'Next',
    periodicity: 'Periodicity',
    execution: 'Execution',
    process: 'Process',
    enterProcess: 'Enter a process',
    recurrent: 'Recurrent',
    single: 'Single',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    scheduling: 'Scheduling',
    parameterization: 'Parameterization',
    conclude: 'Conclude',
    firstExecution: 'First Execution',
    hour: 'Hour',
    day: 'Day',
    weekDays: 'Week days',
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    parameters: 'Parameters',
    yes: 'Yes',
    no: 'No',
    notReported: 'Not reported',
    periodicityData: 'Periodicity data',
    confirmation: 'Confirmation',
    confirmSaveMessage: 'Are you sure you want to complete this schedule?',
    confirmUpdateMessage: 'Are you sure you want to update this schedule?',
    saveNotificationSuccessUpdate: 'Successfully updated scheduling',
    saveNotificationSuccessSave: 'Successfully saved scheduling',
    parametersNotFound: 'Parameters not found.'
  },
  es: {
    at: 'a las',
    back: 'Volver',
    next: 'Avanzar',
    periodicity: 'Periodicidad',
    execution: 'EjecuciÃ³n',
    process: 'Proceso',
    enterProcess: 'Informe un proceso',
    recurrent: 'Recurrente',
    single: 'Ãnica',
    daily: 'Diaria',
    weekly: 'Semanal',
    monthly: 'Mensual',
    scheduling: 'ProgramaciÃ³n',
    parameterization: 'ParametrizaciÃ³n',
    conclude: 'Completar',
    firstExecution: 'Primera ejecuciÃ³n',
    hour: 'Horario',
    day: 'DÃ­a',
    weekDays: 'Dias de la semana',
    sunday: 'Domingo',
    monday: 'Lunes',
    tuesday: 'Martes',
    wednesday: 'MiÃ©rcoles',
    thursday: 'Jueves',
    friday: 'Viernes',
    saturday: 'SÃ¡bado',
    parameters: 'ParÃ¡metros',
    yes: 'SÃ­',
    no: 'No',
    notReported: 'No informado',
    periodicityData: 'Dados da periodicidade',
    confirmation: 'ConfirmaciÃ³n',
    confirmSaveMessage: 'Â¿EstÃ¡ seguro de que desea completar esta programaciÃ³n de proceso?',
    confirmUpdateMessage: 'Â¿EstÃ¡ seguro de que desea cambiar esta programaciÃ³n de proceso?',
    saveNotificationSuccessUpdate: 'ProgramaciÃ³n de proceso actualizada con Ã©xito.',
    saveNotificationSuccessSave: 'ProgramaciÃ³n de proceso salvo con Ã©xito.',
    parametersNotFound: 'No se encontraron parÃ¡metros.'
  },
  pt: {
    at: 'Ã s',
    back: 'Voltar',
    next: 'AvanÃ§ar',
    periodicity: 'Periodicidade',
    execution: 'ExecuÃ§Ã£o',
    process: 'Processo',
    enterProcess: 'Informe um processo',
    recurrent: 'Recorrente',
    single: 'Ãnica',
    daily: 'DiÃ¡ria',
    weekly: 'Semanal',
    monthly: 'Mensal',
    scheduling: 'Agendamento',
    parameterization: 'ParametrizaÃ§Ã£o',
    conclude: 'Concluir',
    firstExecution: 'Primeira execuÃ§Ã£o',
    hour: 'HorÃ¡rio',
    day: 'Dia',
    weekDays: 'Dias de semana',
    sunday: 'Domingo',
    monday: 'Segunda-feira',
    tuesday: 'TerÃ§a-feira',
    wednesday: 'Quarta-feira',
    thursday: 'Quinta-feira',
    friday: 'Sexta-feira',
    saturday: 'SÃ¡bado',
    parameters: 'ParÃ¢metros',
    yes: 'Sim',
    no: 'NÃ£o',
    notReported: 'NÃ£o informado',
    periodicityData: 'Dados da periodicidade',
    confirmation: 'ConfirmaÃ§Ã£o',
    confirmSaveMessage: 'Tem certeza que deseja concluir este agendamento de processo?',
    confirmUpdateMessage: 'Tem certeza que deseja alterar este agendamento de processo?',
    saveNotificationSuccessUpdate: 'Agendamento de processo atualizado com sucesso.',
    saveNotificationSuccessSave: 'Agendamento de processo salvo com sucesso.',
    parametersNotFound: 'ParÃ¢metros nÃ£o foram encontrados.'
  }
};
